<style scoped>
.padding-top-10 {
	padding-top: 10px;
}
.empty-title {
	font-size: 1.5em;
}
</style>

<template>
	<transition name="fade">
		<div v-if="condition" class="fill-height">
			<div class="full-height display-flex display-flex-column">
				<div class="flex-item" />
				<div class="full-width">
					<mu-row class="full-width">
						<mu-col class="full-width">
							<video src="https://vss.hku.hk/vod/vs46600/vox.mp4" preload="none" style="width: 100%" controls :poster="videoDefaultPoster"></video>
						</mu-col>
					</mu-row>
					<mu-row class="full-width padding-top-10">
						<mu-col span="3" />
						<mu-col span="6">
							<mu-flex class="flex-wrapper full-width" justify-content="center">
								<div class="empty-title">Welcome to Vox.</div>
							</mu-flex>
							<mu-flex class="flex-wrapper full-width" justify-content="center">
								<small>{{ message }}</small>
							</mu-flex>
						</mu-col>
						<mu-col span="3" />
					</mu-row>
				</div>
				<div class="flex-item" />
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: "Empty",
	props: {
		condition: {
			type: Boolean,
			default: true,
		},
		message: {
			type: String,
			default: "",
		},
	},
};
</script>
